"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var Styled = _interopRequireWildcard(require("./Styled"));

var _helpertext = _interopRequireDefault(require("@superlogica/helpertext"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = _react.default.forwardRef(function (_ref, ref) {
  var color = _ref.color,
      background = _ref.background,
      defaultValue = _ref.defaultValue,
      label = _ref.label,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      marginLeft = _ref.marginLeft,
      message = _ref.message,
      multiple = _ref.multiple,
      name = _ref.name,
      floatingMessage = _ref.floatingMessage,
      options = _ref.options,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      status = _ref.status,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["color", "background", "defaultValue", "label", "marginTop", "marginRight", "marginBottom", "marginLeft", "message", "multiple", "name", "floatingMessage", "options", "onChange", "onFocus", "status", "value"]);

  var selectRef = ref || (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var op = options.map(function (option, key) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: key,
      value: option.value
    }, option.name);
  });
  return /*#__PURE__*/_react.default.createElement(Styled.Generic, {
    margins: {
      t: marginTop,
      r: marginRight,
      b: marginBottom,
      l: marginLeft
    }
  }, /*#__PURE__*/_react.default.createElement(Styled.Label, {
    htmlFor: name
  }, label), /*#__PURE__*/_react.default.createElement(Styled.Select, _extends({
    ref: selectRef,
    name: name,
    background: background,
    focused: focused,
    color: color,
    multiple: multiple,
    status: status,
    defaultValue: defaultValue,
    onChange: function onChange(data) {
      _onChange(data);
    },
    onFocus: function onFocus(data) {
      setFocused(true);

      _onFocus(data);
    },
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, rest), /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, label), op), /*#__PURE__*/_react.default.createElement(_helpertext.default, {
    status: status,
    message: message,
    floating: floatingMessage
  }));
});

Select.displayName = 'Select';
Select.propTypes = {
  background: _propTypes.string,
  color: _propTypes.string,
  label: _propTypes.string,
  marginTop: _propTypes.string,
  marginRight: _propTypes.string,
  marginBottom: _propTypes.string,
  marginLeft: _propTypes.string,
  multiple: _propTypes.bool,
  name: _propTypes.string,
  onFocus: _propTypes.func,
  onChange: _propTypes.func,
  options: _propTypes.array,
  defaultValue: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool, _propTypes.number]),
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool, _propTypes.number]),
  floatingMessage: _propTypes.bool,
  message: _propTypes.string,
  status: (0, _propTypes.oneOf)(['', 'error', 'success'])
};
Select.defaultProps = {
  background: 'ghost',
  color: 'neutral',
  defaultValue: null,
  label: '',
  options: [],
  marginTop: 'none',
  marginRight: 'none',
  marginBottom: 'none',
  marginLeft: 'none',
  multiple: false,
  name: '',
  value: '',
  floatingMessage: false,
  message: '',
  status: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {}
};
var _default = Select;
exports.default = _default;